import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

const ScreenOverlay = ({ fullScreen, extended }) => {
  const extendStyling = extended ? { top: 0, left: 0 } : {};
  return (
    <>
      {fullScreen ? (
        <Modal
          show={true}
          centered
          backdrop='static'
          keyboard={false}
          dialogClassName='bg-transparent border-0 shadow-none'
          contentClassName='bg-transparent border-0 shadow-none'
        ></Modal>
      ) : (
        <div
          className='w-100 h-100 position-absolute d-flex flex-column align-items-center justify-content-center'
          style={{ backgroundColor: '#000', opacity: 0.3, zIndex: 50, ...extendStyling }}
        ></div>
      )}
    </>
  );
};

ScreenOverlay.propTypes = {
  fullScreen: PropTypes.bool,
  extended: PropTypes.bool,
};
export default ScreenOverlay;
